export const CreateUrlWithParams = (url, params) => {
  let i = 0
  for (let key in params) {
    if (typeof params[key] !== 'undefined' && params[key] !== null) {
      if (i === 0) {
        url += '?'
      } else {
        url += '&'
      }
      if (typeof params[key] === 'object') {
        url += `${key}=${JSON.stringify(params[key])}`
      } else {
        if (params[key]) {
          url += `${key}=${params[key]}`
        }
      }
    }
    i++
  }
  return url
}



// WEBPACK FOOTER //
// ./src/api/helpers.js